import { Injectable } from '@angular/core';
import { HttpClientWrapper } from './httpclientwrapper';
import { Observable } from 'rxjs';
import { AutoComplete, AutoCompleteNew } from '../models/autocomplete';
import { IsNotNull, IsNotNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteService {

    constructor(private http: HttpClientWrapper) { }

    baseUrl: string = this.http.BaseUrl + "api/AutoComplete/";

    getAutoComplete(pattern: string): Observable<AutoComplete[]> {
       
        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "locations?pattern=" + pattern);
    }

    //this api is being used in Location-auto-complete-with-post-code.component.ts File then this component is being used as a selector in other component
    // multiple-location-with-post-code.component.html => then this component Selector is being use in Registration flow-pop-up.component
    GetAutoCompletePostCodelocations(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "PostCodelocations?pattern=" + pattern);
    }

    getSectorsAutoComplete(pattern: string,searchInParent:boolean = true,searchInChildren:boolean = true): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "sectors?prefix=" + pattern+"&searchInParent="+searchInParent+"&searchInChildren="+searchInChildren);
    }

    getSkillsAutoComplete(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "skills?prefix=" + pattern);
    }

    getLocalitiesAutoComplete(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "localities?pattern=" + pattern);
    }

    getAreasAutoComplete(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "areas?pattern=" + pattern);
    }

    getCountiesAutoComplete(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "counties?pattern=" + pattern);
    }

    getPostCodesAutoComplete(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "postCodes?pattern=" + pattern);
    }

    getCountriesAutoComplete(pattern: string): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "countries?pattern=" + pattern);
    }

    getUserJobsTitles(userId: number): Observable<AutoComplete[]> {

        return this.http.GetAsync<AutoComplete[]>(this.http.BaseUrl + "api/Jobs/GetJobsTitlesByUserAsync/" + userId);
      }

    GetAllSectorsAutoComplete(searchInParent: boolean = true, searchInChildren: boolean = true, pattern: string = ""): Observable<AutoComplete[]> {
        let requestPramas = "?";

        if (IsNotNullOrEmpty(pattern)) {
            requestPramas += "prefix=" + pattern;
        }

        if (IsNotNull(searchInParent)) {
            requestPramas += (requestPramas == "?" ? "" : "&") + "searchInParent=" + searchInParent;
        }

        if (IsNotNull(searchInChildren)) {
            requestPramas += (requestPramas == "?" ? "" : "&") + "searchInChildren=" + searchInChildren;
        }

        return this.http.GetAsync<AutoComplete[]>(this.baseUrl + "searchsectors" + requestPramas);
    }
     
    GetAllParentSectors(): Observable<AutoCompleteNew[]> {
        return this.http.GetAsync<AutoCompleteNew[]>(`${this.http.TransmitterApiBaseUrl}api/AutoComplete/AllParentSectors`);
    }

    GetJobTitlesByParentSectors(parentSectorIds: number[]): Observable<AutoCompleteNew[]> {
        return this.http.PostAsync<AutoCompleteNew[]>(`${this.http.TransmitterApiBaseUrl}api/AutoComplete/JobTitlesByParentSectors`, parentSectorIds);
    }
}
